import { render } from "./sort_link.vue?vue&type=template&id=4059f1d8&scoped=true&lang=pug"
import script from "./sort_link.vue?vue&type=script&lang=js"
export * from "./sort_link.vue?vue&type=script&lang=js"

import "./sort_link.vue?vue&type=style&index=0&id=4059f1d8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4059f1d8"]])

export default __exports__